import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Loader from '../../components/loader';
import Modal from '../../components/modal';
import AssetConfig from '../../components/assetconfig';
import ToastHandler from '../../components/toasthandler';

import {
  fetchAddresses,
  addNewAddress,
  updateAddress,
} from '../../actions';

const dateFormat = 'L LT';

class NewAddressModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      asset: 'BTC',
      nickname: '',
      address: '',
      tag: '',
      otp: '',
      pristine: true,
      state: 'NEW',
      manualYubiKey: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.newAddress = this.newAddress.bind(this);
    this.showCrypto = this.showCrypto.bind(this);
    this.confirmTfaStage = this.confirmTfaStage.bind(this);
    this.toggleYubikeyListener = this.toggleYubikeyListener.bind(this);
    this.captureYubiKey = this.captureYubiKey.bind(this);
    this.toggleYubiKeyManual = this.toggleYubiKeyManual.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
  }

  componentWillUnmount() {
    this.toggleYubikeyListener('DISABLE');
  }

  toggleYubikeyListener(type) {
    if (type === 'ENABLE') {
      document.addEventListener('keypress', this.captureYubiKey, false);
    }
    if (type === 'DISABLE') {
      document.removeEventListener('keypress', this.captureYubiKey, false);
    }
  }

  toggleYubiKeyManual() {
    const { manualYubiKey } = this.state;
    if (!manualYubiKey) {
      this.toggleYubikeyListener('DISABLE');
    } else {
      this.toggleYubikeyListener('ENABLE');
    }
    this.setState({manualYubiKey: !manualYubiKey, otp: ''})
  }

  captureYubiKey(e) {
    const { user } = this.props;
    const { otp } = this.state;
    if (e.which === 13 || e.key === 'Enter') {
      this.handleSubmit(e);
      return;
    }
    let useYubikey = '' + e.key;
    if (otp) {
      useYubikey = otp + e.key;
    }
    this.setState({otp: useYubikey});
  }

  confirmTfaStage() {
    const { user } = this.props;
    let yubiEnabled;
    if (user.security) {
      const yubiHandle = user.security.find(e => e.typeHandle === 'YUBIKEY');
      if (yubiHandle && yubiHandle.statusHandle === 'ACTIVATED') {
        yubiEnabled = true;
      }
    }
    if (yubiEnabled) {
      this.toggleYubikeyListener('ENABLE');
    }
    this.setState({step: 'CONFIRM'});
  }

  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value, pristine: false });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { asset, nickname, address, tag, otp } = this.state;
    const { dispatch, user } = this.props;

    let yubiEnabled;

    if (user.security) {
      const yubiHandle = user.security.find(e => e.typeHandle === 'YUBIKEY');
      if (yubiHandle && yubiHandle.statusHandle === 'ACTIVATED') {
        yubiEnabled = true;
      }
    }

    const data = {
      asset,
      nickname,
      address,
      tag,
      otp,
    }

    this.setState({pristine: true});
    dispatch(addNewAddress(data))
      .then((res) => {
        if (res.type === 'CREATE_ADDRESSBOOK_ADDRESS_SUCCESS') {
          if (yubiEnabled) {
            this.toggleYubikeyListener('DISABLE');
          }
          this.setState({step: 'ADDED'})
          dispatch(fetchAddresses());
        }
      });
  }

  newAddress() {
    this.setState({step: 'NEW', pristine: true, asset: 'BTC', nickname: '', address: '', tag: '', otp: ''})
  }

  showCrypto(asset) {
    const { assets } = this.props;
    let assetData;
    if (assets && assets.length) {
      assetData = assets.find((item) => {
        return item.handle === asset;
      });
    }
    let send;
    let receive;
    if (assetData && assetData.defaults) {
      send = assetData.defaults.some((e) => Object.prototype.hasOwnProperty.call(e, 'SEND'));
      receive = assetData.defaults.some((e) => Object.prototype.hasOwnProperty.call(e, 'RECV'));
    }
    let assetConf;
    if (AssetConfig && AssetConfig.length) {
      assetConf = AssetConfig.find((item) => item.handle === asset.toUpperCase());
    }
    let assetEnabled;
    if (assetConf && assetConf.enabled) {
      assetEnabled = assetConf.enabled;
    }
    if (assetEnabled && (send || receive)) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    const { asset, nickname, address, tag, step, pristine, otp, manualYubiKey } = this.state;
    const { addressbook, errors, success, assets, user } = this.props;

    const assetLoop = assets && assets.length && assets.map((value, index) => {
      let handle;
      let humHandle;
      let urlAsset;
      if (value.handle) {
        handle = value.handle;
      }
      if (value.name) {
        humHandle = value.name;
      }
      if (humHandle) {
        urlAsset = humHandle.replace(/\s+/g, '-').toLowerCase();
      }

      if (this.showCrypto(handle)) {
        return (
          <option key={`asset-${index}`} value={handle}>{handle} | {humHandle}</option>
        );
      }
      return (null);
    });

    const complete = !pristine && asset && address;
    const completeOtp = !pristine && asset && address && otp;

    let otpEnabled;
    let yubiEnabled;

    if (user.security) {
      const otpHandle = user.security.find(e => e.typeHandle === 'OTP');
      if (otpHandle && otpHandle.statusHandle === 'ACTIVATED') {
        otpEnabled = true;
      }
      const yubiHandle = user.security.find(e => e.typeHandle === 'YUBIKEY');
      if (yubiHandle && yubiHandle.statusHandle === 'ACTIVATED') {
        yubiEnabled = true;
      }
    }

    if (step === 'ADDED') {
      return (
        <div className="cell small-12 medium-12 large-12">
          <div className="grid-x">
            <div className="cell small-12 medium-12 large-12">
              <div className="modal-heading">Address Added Successfully</div>
            </div>
            <div className="cell small-12 medium-12 large-12">
              <p>The following address was successfully added:</p>
              <p style={{maxWidth: '420px', textAlign: 'left', margin: 'auto'}}>
                <b>Asset: </b>{asset}
                <br/>
                <b>Nickname: </b>{nickname}
                <br/>
                <b>Address: </b>{address}
                <br/>
                <b>Tag: </b>{tag}
              </p>
              <p>You can click below to add another or return to the previous screen.</p>
            </div>
            <div className="cell small-12 medium-12 large-12 modal-actions">
              <button className="button" type="button" onClick={() => this.props.toggleModal(null)}>
                <span>
                  Close
                </span>
              </button>
              <button className="vlt-button" type="button" onClick={() => this.newAddress()}>
                <span>
                  Add another address
                </span>
              </button>
            </div>
          </div>
        </div>
      );
    }

    if (step === 'CONFIRM') {
      return (
        <div className="cell small-12 medium-12 large-12">
          <div className="grid-x">
            <div className="cell small-12 medium-12 large-12">
              <div className="modal-heading">Confirm New Address</div>
            </div>
            <div className="cell small-12 medium-12 large-12">
              <p>The following address will be added:</p>
              <p style={{maxWidth: '420px', textAlign: 'left', margin: 'auto'}}>
                <b>Asset: </b>{asset}
                <br/>
                <b>Nickname: </b>{nickname}
                <br/>
                <b>Address: </b>{address}
                <br/>
                <b>Tag: </b>{tag}
              </p>
            </div>
            {otpEnabled ? (
              <>
                <div className="cell small-12 medium-12 large-12">
                  <div className="text-center">
                    <p>
                      <b>
                        Two-Factor Auth Code
                      </b>
                    </p>
                    <input className="modal-input" type="text" name="otp" placeholder="Two-Factor Auth"  autoComplete="off" id="otp" value={otp} onChange={this.handleChange} />
                  </div>
                </div>
                <div className="cell small-12 medium-12 large-12 modal-actions">
                  <button className="button" type="button" onClick={() => this.props.toggleModal(null)}>
                    <span>
                      Cancel
                    </span>
                  </button>
                  <button className="vlt-button" type="button" disabled={!completeOtp} onClick={(e) => this.handleSubmit(e)}>
                    <span>
                      Confirm
                    </span>
                  </button>
                </div>
              </>
            ) : null }
            {yubiEnabled ? (
              <>
                <div className="cell small-12 medium-12 large-12">
                  <div className="text-center">
                    <div>
                      <h2>
                        YubiKey Auth
                      </h2>
                      <p>
                        1. Insert your YubiKey into a USB port
                        <br />
                        {manualYubiKey ? (
                          '2. Enter your YubiKey code in the field below'
                        ) : (
                          '2. Touch the YubiKey button'
                        )}
                      </p>
                    </div>
                    <div>
                      <div>
                        <img alt="YubiKeys" src={ process.env.REACT_APP_CDN + '/assets/images/yubikeys.png'} style={{maxWidth: '80%', marginBottom: '20px'}}/>
                      </div>
                      {manualYubiKey ? (
                        <div>
                          <input id="otp" className="modal-input" type="password" name="otp" placeholder="Enter YubiKey" value={otp} autoComplete="off" onChange={this.handleChange} autoFocus />
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="cell small-12 medium-12 large-12 modal-actions">
                  <button className="button" type="button" onClick={() => this.props.toggleModal(null)}>
                    <span>
                      Cancel
                    </span>
                  </button>
                  {manualYubiKey ? (
                    <button className="vlt-button" type="button" disabled={!completeOtp} onClick={(e) => this.handleSubmit(e)}>
                      <span>
                        Confirm
                      </span>
                    </button>
                  ) : (
                    <button className="button" type="submit" onClick={this.toggleYubiKeyManual}>
                      <span>
                        Manual YubiKey Confirmation
                      </span>
                    </button>
                  )}
                </div>
              </>
            ) : null }
          </div>
        </div>
      );

    }

    return (
      <div className="cell small-12 medium-12 large-12">
        <div className="grid-x">
          <div className="cell small-12 medium-12 large-12">
            <div className="modal-heading">New Address</div>
            <div className="modal-subheading">
              Fill in the form below to add a new crypto address.
            </div>
          </div>
          <div className="cell small-12 medium-12 large-12">
            <div className="input-wrapper">
              <p className="iw-l">Asset:</p>
              <select id="asset" className="modal-input" value={asset} onChange={this.handleChange}>
                {assetLoop}
              </select>
            </div>
            <div className="input-wrapper">
              <p className="iw-l">Nickname:</p>
              <input id="nickname" className="modal-input" type="text" name="nickname" placeholder="Nickname" value={nickname} onChange={this.handleChange} />
            </div>
            <div className="input-wrapper">
              <p className="iw-l">Address:</p>
              <input id="address" className="modal-input" type="text" name="address" placeholder="Address" value={address} onChange={this.handleChange} />
            </div>
            <div className="input-wrapper">
              <p className="iw-l">Tag:</p>
              <input id="tag" className="modal-input" type="text" name="tag" placeholder="Tag" value={tag} onChange={this.handleChange} />
            </div>
          </div>
          <div className="cell small-12 medium-12 large-12 modal-actions">
            <button className="button" type="button" onClick={() => this.props.toggleModal(null)}>
              <span>
                Cancel
              </span>
            </button>
            <button className="vlt-button" type="button" disabled={!complete} onClick={() => this.confirmTfaStage()}>
              <span>
                Next
              </span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  errors: state.addressbook.errors,
  success: state.addressbook.success,
  addressbook: state.addressbook.addressbook,
  assets: state.assets.assets,
});

export default connect(mapStateToProps)(NewAddressModal);
